'use client'

import { usePathname } from 'next/navigation'
import ChatButton from '@/components/shared/ChatButton'

export function ChatButtonWrapper() {
  const pathname = usePathname()
  
  // Don't show on the main page
  if (pathname === '/') {
    return null
  }
  
  // Add hidden md:block to hide on mobile
  return (
    <div className="hidden md:block">
       <ChatButton />
    </div>
  )
} 